import { ComponentType } from '@angular/cdk/portal';
import { Router } from '@angular/router';
import { NavigationRoutes } from '../routes/app.routes.definition';
import { NavigationHelper } from '../routes/app.routes.helper';

//#region EXTENSION METHODS FOR ANGULAR ROUTER

/* eslint-disable */
declare module '@angular/router' {
    export interface Router {
        Routes: NavigationRoutes;
        NavigateTo: NavigationHelper;
        GetNavigationParameter<T>(component: ComponentType<any>): T;
        InitializeExtensionMethods(): void;
    }
}

Router.prototype.InitializeExtensionMethods = function () {
    const router = (this as unknown as Router);
    if (!router.NavigateTo) {
        router.NavigateTo = new NavigationHelper(router);
    }
};

/* eslint-enable */
